import type { ReactNode } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { useAnmeldung } from './lib/anmeldung'
import { Kopfzeile } from './teile/Kopfzeile'
import { AnmeldungSeite } from './seiten/Anmeldung'
import { EingangSeite } from './seiten/Eingang'
import { MandantenSeite } from './seiten/Mandanten'
import { MandantSeite } from './seiten/Mandant'
import { ExporteSeite } from './seiten/Exporte'
import { AuszugSeite } from './seiten/Auszug'
import { VerwaltungSeite } from './seiten/Verwaltung'

/** Rahmen fuer alle Arbeitsseiten. Die Reiterzeile benennt die Seite. */
function Rahmen({ children }: { children: ReactNode }) {
  return (
    <>
      <Kopfzeile />
      <main className="inhalt">{children}</main>
    </>
  )
}

export function App() {
  const { auskunft, laedt } = useAnmeldung()

  if (laedt) return <div className="laedt">Einen Moment …</div>
  if (!auskunft) return <AnmeldungSeite />

  // Die Verwaltung (H&K) sieht Kanzleien und Zugaenge, keine Mandantendaten.
  if (auskunft.benutzer.rolle === 'verwaltung') {
    return (
      <Routes>
        <Route path="/verwaltung" element={<Rahmen><VerwaltungSeite /></Rahmen>} />
        <Route path="*" element={<Navigate to="/verwaltung" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/eingang" replace />} />
      <Route path="/eingang" element={<Rahmen><EingangSeite /></Rahmen>} />
      <Route path="/mandanten" element={<Rahmen><MandantenSeite /></Rahmen>} />
      <Route path="/mandanten/:id" element={<Rahmen><MandantSeite /></Rahmen>} />
      <Route path="/exporte" element={<Rahmen><ExporteSeite /></Rahmen>} />
      {/* Bewusst ohne Rahmen: im geoeffneten Auszug gehoert der Bildschirm
          dem Auszug, die Hauptnavigation tritt zurueck. */}
      <Route path="/auszuege/:id" element={<AuszugSeite />} />
      <Route path="*" element={<Navigate to="/eingang" replace />} />
    </Routes>
  )
}
